import AddToCart from "@/elements-react/add-to-cart";
import { LayoutStyleTypes } from "@/util-react/layout";
import ViewDetails from "@/elements-react/view-details";
import { googleEvent } from "@/helpers/google-events";
import { useState } from "preact/hooks";
import classNames from "classnames";
import React from "preact/compat";

interface ProductElementButtonPropsFactoryProps {
  productId: string;
}

interface ProductElementButtonProps {
  buttonClass: string;
  actionClassNames: { "state-active": boolean; "state-hover": boolean };
  added: boolean;
  handleCartClick: () => void;
  productId: string;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  handleMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
  handleMouseUp: (e: React.MouseEvent<HTMLDivElement>) => void;
}

interface ProductElementButtonModeProps {
  mode: "cart" | "details" | undefined;
}

export const productElementButtonPropsFactory = (props: ProductElementButtonPropsFactoryProps): ProductElementButtonProps => {
  const { productId } = props;
  const [added, setAdded] = useState(false);
  const [cursorPending, setCursorPending] = useState(false);
  const [clickPending, setClickPending] = useState(false);
  const handleCartClick = () => setAdded(true);
  const handleMouseEnter = () => setCursorPending(true);
  const handleMouseLeave = () => {
    setCursorPending(false);
    setClickPending(false);
  };
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.button === 0) setClickPending(true);
  };
  const handleMouseUp = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.button === 0) setClickPending(false);
  };

  const getActionClassNames = () => ({
    "state-active": clickPending,
    "state-hover": !clickPending && cursorPending,
  });

  const actionClassNames = getActionClassNames();

  const buttonClass = classNames("cart", actionClassNames);

  return {
    buttonClass,
    actionClassNames,
    added,
    handleCartClick,
    productId,
    handleMouseEnter,
    handleMouseLeave,
    handleMouseDown,
    handleMouseUp,
  };
};

export const ProductElementButton = (props: ProductElementButtonProps & ProductElementButtonModeProps) => {
  const { mode, buttonClass, added, handleCartClick, productId } = props;

  return mode === "cart" ? (
    <AddToCart className={buttonClass} type={LayoutStyleTypes.TYPE_SM} done={added} onClick={handleCartClick} />
  ) : (
    <ViewDetails className={buttonClass} type={LayoutStyleTypes.TYPE_SM} onClick={() => googleEvent("product_click", productId)} />
  );
};
